module.exports = __webpack_public_path__ + "img/disney-banner.badb2c18.svg";